import React from "react";

const cities = [
  { id: 1, name: "Austin" },
  { id: 2, name: "Gainesville" },
  { id: 3, name: "Jacksonville" },
  { id: 4, name: "Tampa" },
  { id: 5, name: "St. Petersburg" },
  { id: 6, name: "Orlando" },
  { id: 7, name: "St. Louis" },
  { id: 8, name: "DFW" },
  // Adding more dummy cities to better demonstrate the multi-column layout
  { id: 9, name: "Dallas" },
  { id: 10, name: "Houston" },
  { id: 11, name: "San Antonio" },
  { id: 12, name: "Fort Worth" },
  { id: 13, name: "Miami" },
  { id: 14, name: "Atlanta" },
  { id: 15, name: "Phoenix" },
  { id: 16, name: "Seattle" },
];

const CitiesPage = () => {
  const columns = 3; // Using 3 columns for better alignment matching the image's city list
  const chunkSize = Math.ceil(cities.length / columns);
  const cityChunks = [];

  for (let i = 0; i < cities.length; i += chunkSize) {
    cityChunks.push(cities.slice(i, i + chunkSize));
  }

  // --- Styles for Uber-like appearance ---

  const linkStyle = {
    fontSize: "16px",
    color: "#111",
    textDecoration: "none", // Remove default underline
    borderBottom: "1px solid #111", // Use border for the thin underline look
    paddingBottom: "1px",
    marginBottom: "40px",
    display: "inline-block",
    cursor: "pointer",
  };

  const cityLinkStyle = {
    fontSize: "16px",
    fontWeight: 400,
    color: "#111",
    margin: "8px 0", // Increased vertical spacing
    cursor: "pointer",
    textDecoration: "none",
    borderBottom: "1px solid transparent", // Hidden border for consistent spacing
    transition: "border-color 0.1s ease",
  };

  return (
    // ✅ 1. Remove unnecessary display flex properties for the container.
    <div
      style={{
        fontFamily: "'Uber Move Text', 'Helvetica Neue', Helvetica, Arial, sans-serif",
        backgroundColor: "#fff",
        minHeight: "100vh",
        padding: "40px 0", // Padding on top/bottom
      }}
    >
      {/* ✅ 2. Main Wrapper: Sets maximum width and centers itself using margin: '0 auto'. */}
      {/* ✅ 3. Content is left-aligned by default inside this container. */}
      <div 
        style={{ 
            maxWidth: "1024px", // Wider container to hold the content
            width: "90%",
            margin: "0 auto", // Centers the container
            padding: "0 24px", // Padding inside the container
            textAlign: "left", // Essential: ensures all content is left-aligned
        }}
      >
        {/* Main Header */}
        <h1
          style={{
            fontSize: "48px",
            fontWeight: 900,
            color: "#111",
            marginTop: "100px", // Increased space above the main heading
            marginBottom: "20px",
            maxWidth: "600px", // Constrain title width
            lineHeight: "1.1",
          }}
        >
          Use BERYMO in cities around the world
        </h1>

        {/* Description */}
        <p
          style={{
            fontSize: "16px",
            color: "#111",
            marginBottom: "10px",
            lineHeight: "1.5",
          }}
        >
          Get to your destination in more than **10** cities. If you're
          going to an airport, see all airports where BERYMO is available.
        </p>

        {/* See fares link (using standard anchor tag for simplicity) */}
        <a
          href="/pricing"
          style={linkStyle}
        >
          See fares
        </a>

        {/* Horizontal Rule/Separator based on image layout */}
        <div style={{ height: "1px", backgroundColor: "#e2e2e2", margin: "40px 0" }}></div>

        {/* Global heading */}
        <h2
          style={{
            fontSize: "18px",
            fontWeight: 700,
            color: "#111",
            marginBottom: "30px",
            marginTop: "20px",
          }}
        >
          Global
        </h2>

        {/* City columns wrapper */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "20px 40px", // Vertical and horizontal gap
          }}
        >
          {cityChunks.map((chunk, colIndex) => (
            <ul
              key={colIndex}
              style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                // Distribute columns evenly
                flex: `1 0 ${100 / columns - 5}%`, 
                minWidth: '200px',
              }}
            >
              {chunk.map((city) => (
                <li
                  key={city.id}
                  style={cityLinkStyle}
                  // Simulating the clickable link look
                >
                  {/* <a 
                    href={`/cities/${city.name.toLowerCase().replace(/\s/g, '-')}`}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                    onMouseOver={(e) => (e.currentTarget.parentNode.style.borderBottom = "1px solid #111")}
                    onMouseOut={(e) => (e.currentTarget.parentNode.style.borderBottom = "1px solid transparent")}
                  > */}
                    {city.name}
                  {/* </a> */}
                </li>
              ))}
            </ul>
          ))}
        </div>

      </div>
    </div>
  );
};

export default CitiesPage;
